import { useEffect, useState } from 'react';
import { fetchEVNs } from '../services/evn.api';

export function useEVNs(transform) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const list = await fetchEVNs(ctrl.signal);
        setData(typeof transform === 'function' ? transform(list) : list);
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('useEVNs error:', err);
          setError(err);
          setData([]);
        }
      } finally {
        setLoading(false);
      }
    })();
    return () => ctrl.abort();
  }, [transform]);

  return { data, loading, error };
}
